/**
* @constructor
* Detect when elements are in the viewport
*
* @param {selector} The elements we want to observe
* @param {once} If true, the state is defined once (doesn't go back to hidden when the element leave the viewport)
*/

export default function IsInView(selector, once = true) {

	const elements = document.querySelectorAll(selector);

	const observer = new IntersectionObserver(
		(changes) => {
			
			changes.forEach((change) => {
				if (change.isIntersecting === true) {
					change.target.classList.add('is-in-view');
				} else if (change.isIntersecting !== true && once !== true) {

					change.target.classList.remove('is-in-view');
					const cl = "." + change.target.id;
					const currentSec = document.querySelector(cl);
					currentSec.removeAttribute('aria-current');
				}
			});

		}
	);

	this.init = () => {

		elements.forEach((element) => {

			element.classList.remove('is-in-view');
			observer.observe(element);

		});

	};

}
